export default {
    LOAD_SPOTS(state, spots) {
        state.items = spots;
    }
}